import { Headline6 } from '@nexus/lib-react/dist/core/Typography/Heading';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import styled from '../../../../../theme/styled';
import { progressiveLoading } from '../../../../../commons/styles/animations';

export const Card = styled.div`
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.fonts.primary};
  background: ${({ theme }) => theme.colors.bgPrimary};
  padding: 16px;
  display: flex;
  flex-flow: column;
`;

export const Title = styled(Headline6)`
  text-transform: uppercase;
  margin-bottom: 8px;
`;

export const SubTitle = styled(Paragraph4)`
  margin-bottom: 32px;

  &:empty {
    height: 16px;
    width: 40%;
    ${progressiveLoading()}
  }
`;

export default { Card, Title, SubTitle };
